const INITIAL_STATE = {
    mensagem:'',
    esperandoRespostaSolicitacao: false,
    avaliacoes:[],
    links:{},
    error: false
};

export default (state = INITIAL_STATE, action) => {
    
    switch (action.type){

        //CRIAR ACOMPANHAMENTO
        case 'AVALIADOR_CRIAR_ACOMPANHAMENTO_SOLICITADO':
            return {...state};
        case 'AVALIADOR_CRIAR_ACOMPANHAMENTO_RECEBIDO':
            return {...state};
        case 'AVALIADOR_CRIAR_ACOMPANHAMENTO_ERRO':
            return {...state};

        //RECUPERAR ACOMPANHAMENTO
        case 'AVALIADOR_RECUPERAR_ACOMPANHAMENTO_SOLICITADO':
            return {...state};
        case 'AVALIADOR_RECUPERAR_ACOMPANHAMENTO_RECEBIDO':
            return {...state};
        case 'AVALIADOR_RECUPERAR_ACOMPANHAMENTO_ERRO':
            return {...state};

        //CRIAR LINK_AVALIACAO
        case 'AVALIADOR_OBTER_LINK_AVALIACAO_SOLICITADO':
            return {...state, esperandoRespostaSolicitacao:true};
        case 'AVALIADOR_OBTER_LINK_AVALIACAO_RECEBIDO':
            let newlinks = {...state.link,...action.payload};
            return {...state,esperandoRespostaSolicitacao:false,links:newlinks};
        case 'AVALIADOR_OBTER_LINK_AVALIACAO_ERRO':
            return {...state,esperandoRespostaSolicitacao:false, mensagem:action.payload};

        //OBTER AVALICOES DO CPF
        case 'AVALIADOR_OBTER_AVALIACAO_POR_CIDADAO_SOLICITADO':
            return {...state, esperandoRespostaSolicitacao:true};
        case 'AVALIADOR_OBTER_AVALIACAO_POR_CIDADAO_RECEBIDO':
            return {...state, esperandoRespostaSolicitacao:false,avaliacoes:action.payload};
        case 'AVALIADOR_OBTER_AVALIACAO_POR_CIDADAO_ERRO':
            return {...state, esperandoRespostaSolicitacao:false,avaliacoes:[],mensagem:action.payload};

        //LIMPAR A LISTA DE AVALIACOES PARA RECARREGA-LA
        case 'AVALIADOR_LIMPAR_AVALIACOES':
            return {...state,  
                mensagem:'',
                esperandoRespostaSolicitacao: false,
                avaliacoes:[],
                links:{},
                error: false
            }

            //CRIAR AVALIACAO
        case 'AVALIADOR_CRIAR_AVALIACAO_SOLICITADO':
            return {...state, esperandoRespostaSolicitacao:true};
        case 'AVALIADOR_CRIAR_AVALIACAO_RECEBIDO':
            return {...state, esperandoRespostaSolicitacao:false, error: false};
        case 'AVALIADOR_CRIAR_AVALIACAO_ERRO':
            return {...state, esperandoRespostaSolicitacao:false,avaliacoes:[],mensagem:action.payload, error: true};

        case 'AVALIADOR_EXIBIR_LINK_AVALIACAO':
            return {...state};            

        //AVALICAO SE SERVICOS QUE NÃO TEM PROTOCOLO
        case    'AVALIADOR_OBTER_LINK_DIRETO_SOLICITADO':
            return {...state, esperandoRespostaSolicitacao:true, mensagem: '', error: false};
        case    'AVALIADOR_OBTER_LINK_DIRETO_RECEBIDO':
            let newlinksDireto = {...state.link,...action.payload};
            return {...state,esperandoRespostaSolicitacao:false,links:newlinksDireto, error: false};
        case    'AVALIADOR_OBTER_LINK_DIRETO_ERRO':
            return {...state,esperandoRespostaSolicitacao:false, mensagem:action.payload, error: true};
        case    'AVALIADOR_CRIAR_LINK_AVALIACAO_JA_REALIZADA':
            let newlinksDiretoJaAvaliado = {...state.link,"0":"Já avaliado!"};
            return {...state,esperandoRespostaSolicitacao:false,links:newlinksDiretoJaAvaliado};
        case 'AVALIADOR_REDERICIONAR_LINK_DIRETO':
            return {...state,links:{}}
        default:
            return state;
    }
}
